"use client";

import React from "react";
import { cn } from "utils";
import { SnackbarNotification } from "./SnackbarNotification";
import { PortfolioList } from "./PortfolioList";
import { PortfolioButton } from "./PortfolioButton";
import { UpgradeButton } from "./UpgradeButton";
import type { PortfolioContentProps } from "./types";
import { usePortfolioContent } from "@/src/hooks/usePortfolioContent";

export const PortfolioContent: React.FC<PortfolioContentProps> = ({
  className,
  mode = "select",
  onItemClick,
  PortfolioListTitle,
  contentId,
}) => {
  // 使用 hook 获取所有业务逻辑和数据
  const {
    portfolioData,
    isLoading,
    memberLevel,
    shouldShowNotification,
    notificationMessage,
    shouldShowUpgradeButton,
    shouldShowCreateButton,
    createButtonType,
    handleCreatePortfolio,
    handleUpgradeClick,
  } = usePortfolioContent(contentId, mode);

  return (
    <div
      className={cn(
        "bg-background_solid_tertiary relative rounded-2 md:w-60 w-full md:p-0 p-2",
        "shadow-[3px_3px_16px_0px_rgba(0,0,0,0.25)]",
        "md:border md:border-border_white_transparent10",
        className,
      )}
    >
      <div className={cn("flex flex-col items-stretch h-full py-2")}>
        {shouldShowNotification && (
          <SnackbarNotification
            message={notificationMessage}
            icon="info-circle"
          />
        )}

        {!isLoading ? (
          <PortfolioList
            data={portfolioData}
            mode={mode}
            onItemClick={onItemClick}
            onLockedClick={handleUpgradeClick}
            PortfolioListTitle={PortfolioListTitle}
          />
        ) : (
          <div>
            {new Array(4).fill(0).map((_, index) => (
              <div key={index} className="h-10 animate-pulse p-2 last:mb-2">
                <div className="bg-background_white_overlay5 h-full rounded" />
              </div>
            ))}
          </div>
        )}

        {shouldShowCreateButton && (
          <PortfolioButton
            data-openreplay-label="PortfolioContainer · PortfolioContent · PortfolioButton"
            type={createButtonType}
            onClick={handleCreatePortfolio}
          />
        )}

        {shouldShowUpgradeButton && (
          <UpgradeButton
            memberLevel={memberLevel}
            handleUpgradeClick={handleUpgradeClick}
          />
        )}
      </div>
    </div>
  );
};
